<template>
  <Popover class="absolute inset-0">
    <PopoverButton class="absolute inset-0 flex justify-center items-center" @click="show">
      <EllipsisHorizontalIcon class="h-4 w-4 mr-1" />
    </PopoverButton>

    <transition-appear origin="center">
      <PopoverPanel v-if="isOpened" class="absolute top-[5px] right-[5px] w-screen max-w-max" static>
        <OnClickOutside @trigger="close">
          <div class="isolate inline-flex rounded-md shadow-lg">
            <router-link :to="`/sessions?search=${row.userId}`" class="btn-list-action rounded-l-md">
              <UserIcon class="mr-2 h-3 text-slate-400" />
              Filter by this User
            </router-link>

            <button
              class="btn-list-action"
              :disabled="downloadingLogs"
              @click="emit('downloadLogs', row)"
            >
              <ArrowPathIcon
                v-if="downloadingLogs"
                class="mr-2 h-3 text-slate-400 animate-spin"
              />
              <DocumentTextIcon
                v-else
                class="mr-2 h-3 text-slate-400"
              />
              {{ downloadingLogs ? 'Downloading...' : 'Download logs' }}
            </button>

            <button
              class="btn-list-action"
              :disabled="downloadingVideo"
              @click="emit('downloadVideo', row)"
            >
              <ArrowPathIcon
                v-if="downloadingVideo"
                class="mr-2 h-3 text-slate-400 animate-spin"
              />
              <FilmIcon
                v-else
                class="mr-2 h-3 text-slate-400"
              />
              {{ downloadingVideo ? 'Downloading...' : 'Download video' }}
            </button>

            <router-link
              v-if="user.tier === 'admin'"
              :to="`/session/${row.id}`"
              class="btn-list-action rounded-r-md"
            >
              <EyeIcon class="mr-2 h-3 text-slate-400" />
              View
            </router-link>

            <button
              v-if="user.tier === 'admin'"
              class="btn-list-action rounded-r-md"
              :class="isDisabled ? 'opacity-100! text-slate-300!' : ''"
              :disabled="isDisabled"
              @click="emit('terminate', row)"
            >
              <FireIcon
                class="mr-2 h-3"
                :class="isDisabled ? 'text-slate-200' : 'text-slate-400'"
              />
              Terminate
            </button>
          </div>
        </OnClickOutside>
      </PopoverPanel>
    </transition-appear>
  </Popover>
</template>

<script setup>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import TransitionAppear from './TransitionAppear.vue';
import { computed, ref, watch } from 'vue';
import { OnClickOutside } from '@vueuse/components';
import { EllipsisHorizontalIcon, EyeIcon, UserIcon, FireIcon, DocumentTextIcon, FilmIcon } from '@heroicons/vue/24/outline';
import { ArrowPathIcon } from '@heroicons/vue/24/outline';
import { getUser } from '../composables/useAuth';

const props = defineProps({
  row: {
    type: Object,
    default: () => {}
  },
  index: {
    type: Number,
    default: null
  },
  isRowHovered: {
    type: Boolean,
    default: false
  },
  downloadingLogs: {
    type: Boolean,
    default: false
  },
  downloadingVideo: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits([ 'terminate', 'downloadLogs', 'downloadVideo' ]);

const user = getUser();

const isOpened = ref(false);
const isDisabled = computed(() => props.row.state === 'saving' || props.row.state === 'terminating');

watch(() => props.isRowHovered, val => isOpened.value = val);

function show() {
  isOpened.value = true;
}

function close() {
  isOpened.value = false;
}
</script>
